import FilterOperatorModel from './filter_operator';

function getValue(column, value) {
    switch (column.type) {
        case 'number': return value;
        default: return `'${value}'`;
    }
}

// exact match
export const IS = new FilterOperatorModel('is', 'case sensitive', ['equals', '='], (column, values) => `${column.sqlName} = ${getValue(column, values[0])}`, 1);
export const IS_NOT = new FilterOperatorModel('is not', 'equal', ['not equals', '!='], (column, values) => `${column.sqlName} != ${getValue(column, values[0])}`, 1);
export const IS_ONE_OF = new FilterOperatorModel('is one of', 'value1, value2, ...', ['in'], (column, values) => `${column.sqlName} IN (${values.map(value => getValue(column, value)).join("', '")})`, 1);
export const IS_NOT_ONE_OF = new FilterOperatorModel('is not one of', 'value1, value2, ...', ['not in'], (column, values) => `${column.sqlName} NOT IN (${values.map(value => getValue(column, value)).join("', '")})`, 1);

// pattern match
export const CONTAINS = new FilterOperatorModel('contains', undefined, ['like'], (column, values) => `${column.sqlName} LIKE '%${values[0]}%'`, 1);
export const DOES_NOT_CONTAIN = new FilterOperatorModel('does not contain', undefined, ['not like'], (column, values) => `${column.sqlName} NOT LIKE '%${values[0]}%'`, 1);
export const STARTS_WITH = new FilterOperatorModel('starts with', undefined, ['like'], (column, values) => `${column.sqlName} LIKE '${values[0]}%'`, 1);
export const ENDS_WITH = new FilterOperatorModel('ends with', undefined, ['like'], (column, values) => `${column.sqlName} LIKE '%${values[0]}'`, 1);
export const DOES_NOT_START_WITH = new FilterOperatorModel('does not start with', undefined, ['not like'], (column, values) => `${column.sqlName} NOT LIKE '${values[0]}%'`, 1);
export const DOES_NOT_END_WITH = new FilterOperatorModel('does not end with', undefined, ['not like'], (column, values) => `${column.sqlName} NOT LIKE '%${values[0]}'`, 1);
export const MATCHES_REGEX = new FilterOperatorModel('matches regex', undefined, [], (column, values) => `${column.sqlName} REGEXP '${values[0]}'`, 1);

// present
export const IS_EMPTY = new FilterOperatorModel('is empty', undefined, ['null'], column => `${column.sqlName} IS NULL`, 0);
export const IS_NOT_EMPTY = new FilterOperatorModel('is not empty', undefined, ['not null'], column => `${column.sqlName} IS NOT NULL`, 0);

// relative match
const GREATER_THAN = new FilterOperatorModel('greater than', undefined, ['>'], (column, values) => `${column.sqlName} > ${values[0]}`, 1);
const GREATER_THAN_EQUAL = new FilterOperatorModel('greater than or equal', undefined, ['>='], (column, values) => `${column.sqlName} >= ${values[0]}`, 1);
const LESS_THAN = new FilterOperatorModel('less than', undefined, ['<'], (column, values) => `${column.sqlName} < ${values[0]}`, 1);
const LESS_THAN_EQUAL = new FilterOperatorModel('less than or equal', undefined, ['<='], (column, values) => `${column.sqlName} <= ${values[0]}`, 1);
const BETWEEN_INCLUSIVE = new FilterOperatorModel('between and including', undefined, ['>=', '<='], (column, values) => `${column.sqlName} BETWEEN ${values[0]} AND ${values[1]}`, 2);

const GROUP_PRESENT = {heading: 'Present', items: [IS_EMPTY, IS_NOT_EMPTY]};
export const GROUPS = {
    'string': [
        {heading: 'Exact Match', items: [IS, IS_NOT, IS_ONE_OF, IS_NOT_ONE_OF]},
        {heading: 'Pattern Match', items: [CONTAINS, DOES_NOT_CONTAIN, STARTS_WITH, ENDS_WITH, DOES_NOT_START_WITH, DOES_NOT_END_WITH, MATCHES_REGEX]},
        GROUP_PRESENT
    ],
    'number': [
        {heading: 'Exact Match', items: [IS, IS_NOT, IS_ONE_OF, IS_NOT_ONE_OF]},
        {heading: 'Relative Match', items: [GREATER_THAN, GREATER_THAN_EQUAL, LESS_THAN, LESS_THAN_EQUAL, BETWEEN_INCLUSIVE]},
        GROUP_PRESENT
    ],
    'date': [
        {heading: 'Absolute Date', items: [
                new FilterOperatorModel('earlier than', undefined, ['<']),
                new FilterOperatorModel('later than', undefined, ['>']),
                new FilterOperatorModel('between', undefined, ['>', '<']),
                BETWEEN_INCLUSIVE
            ]},
        {heading: 'Relative Date', items: [
                new FilterOperatorModel('last N minutes'),
                new FilterOperatorModel('last N hours'),
                new FilterOperatorModel('last N days'),
                new FilterOperatorModel('last N weeks'),
                new FilterOperatorModel('last N months'),
                new FilterOperatorModel('last N years'),
            ]},
        {heading: 'Between Dates', items: [
                new FilterOperatorModel('between N and M minutes before now'),
                new FilterOperatorModel('between N and M hours before now'),
                new FilterOperatorModel('between N and M days before now'),
                new FilterOperatorModel('between N and M weeks before now'),
                new FilterOperatorModel('between N and M months before now'),
                new FilterOperatorModel('between N and M years before now'),
            ]},
        {heading: 'Current Date', items: [
                new FilterOperatorModel('current day'),
                new FilterOperatorModel('current week'),
                new FilterOperatorModel('current month'),
                new FilterOperatorModel('current quarter'),
                new FilterOperatorModel('current year'),
            ]},
        GROUP_PRESENT
    ]
};


